import {SubmitEventController} from 'nova';
import {COMPILE} from '@acng/frontend-stargazer';
import {guard, IS, OBJECT, STRING} from '@acng/frontend-rubicon';
import {popup} from '@acng/frontend-discovery';

import {post} from '../../core/service/backend.js';
import {t} from '../../locale/config/translate.js';
import {getLocalOverlay} from '../../core/service/overlay.js';

/**
 * @example
 *
 * ```html
 * <!--@ ${auth.settings.mail.change} -->
 * ```
 */
class MailAddressChange extends SubmitEventController {
  /**
   * @param {HTMLFormElement} form
   * @param {FormData} formData
   */
  async submit(form, formData) {
    const url = 'user/change-mail';
    const data = Object.fromEntries(formData);
    ASSERT: guard(data, OBJECT({email: STRING}));

    await post(url, data, form, async (error) => {
      if (error.httpStatus == 409) {
        await popup(form).warn(await t('userPool.changeEmailEntryAlreadyExists'));

        throw null;
      }

      throw error;
    });

    await popup(form).info(await t('userPool.changeEmailCheckMail'));
    getLocalOverlay(form)?.close();
  }

  /**
   * @param {Element} form
   */
  [COMPILE](form) {
    ASSERT: {
      guard(form, IS(HTMLFormElement));
      guard(form.elements, OBJECT({email: IS(HTMLInputElement)}));
    }

    const {email} = form.elements;
    email.type = 'email';
    email.required = true;
  }
}

export {MailAddressChange};
